module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Using soft pastels: is it drawing or painting? This is the question that I am always asked, and the aim of this book is to show you that the answer is both.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Depending on the way you use them, you can draw and paint with pastels, and produce work that ranges from detailed and delicate sketches to vibrant and expressive paintings. You hold the pigment in your hand, so can work immediately and directly, with no drying times to slow you down. You can combine several techniques in one piece, work in layers, and rub out or go over areas that you don’t like. Pastels are versatile, forgiving and fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("This book is for beginners to pastels, whether you are new to art in all its forms, or have experience with other painting media. Many people have dabbled a bit with a few cheap sticks, but would like to understand them and their potential in greater depth.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("As people we are all different; and as developing artists we work in different ways, even with the same materials. That is one of the great things about art. It can sometimes be frustrating when you try something new, but hopefully some of the exercises in the book will feel easier and more natural than others. As the book progresses you will find ways of working that feel right, and if you keep practising, you will develop a style that is your own. Be brave and take risks.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I hope that you will enjoy this journey through the colourful and inspiring world of pastels, and get as much enjoyment from them as I do every day.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f007-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caphead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Trees on Red")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This piece uses soft pastels on a red background. Red is complementary to the green of the leaves, and it is used here to create a feeling of dazzling sunlight. The vibrant contrast creates real impact.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8bc2ed8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 81
// module chunks = 0